// extracted by mini-css-extract-plugin
export default {"searchBar":"Dashboard_searchBar__e3FYA"};